import className from 'classnames';
import React from 'react';
import { toTitleCase } from '../../../Lib/String';
import { IMessageProps, Message } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { IGridData } from '../Grid/types';
import './GridFieldSection.scss';

interface IGridFieldSection {
  heading?: string;
  messages?: IMessageProps[];
  onReceivedData?: (data: IGridData | undefined, hiddenRows: Array<number | null | undefined>) => void;
  visible?: boolean;
  additionalClassName?: string;
}

const GridFieldSectionBase: React.FC<React.PropsWithChildren<IGridFieldSection>> = ({
  children,
  heading,
  messages,
  onReceivedData,
  visible = true,
  additionalClassName,
}) => {
  if (heading) {
    heading = toTitleCase(heading);
  }

  return !visible ? null : (
    <section className={className('GridFieldSection', additionalClassName)}>
      {heading && <h2 className="GridFieldSection-Heading">{heading}</h2>}

      <div className="GridFieldSection-Content">{React.cloneElement(children as any, { onReceivedData })}</div>

      {messages && messages.length > 0 && (
        <div className="GridFieldSection-Messages">
          {messages.map((props, i) => (
            <Message key={i} {...props} />
          ))}
        </div>
      )}
    </section>
  );
};

const GridFieldSection = withInjectedProps(GridFieldSectionBase);

export { GridFieldSection };
export default GridFieldSection;
